export const GRID = { rows: 9, cols: 7 };
export const BOARD_SIZE = GRID.rows * GRID.cols;  



